import { useTranslation } from 'react-i18next';
import { Badge } from '@shared/ui';
import { orderStatusTone, type OrderStatus } from '@entities/order';

export function OrderStatusChip({ status }: { status: OrderStatus }) {
  const { t } = useTranslation();
  return <Badge tone={orderStatusTone(status)}>{t(`orders.status.${status}`)}</Badge>;
}
